import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Email non valida'),
  password: z.string().min(8, 'Password: minimo 8 caratteri'),
  rememberMe: z.boolean().optional(),
});

export const registerSchema = z.object({
  email: z.string().email('Email non valida'),
  password: z.string()
    .min(8, 'Password: minimo 8 caratteri')
    .regex(/[A-Z]/, 'Richiede almeno una maiuscola')
    .regex(/[0-9]/, 'Richiede almeno un numero'),
  nickname: z.string().min(2, 'Nickname: minimo 2 caratteri').max(50, 'Nickname: massimo 50'),
  tenantId: z.number().int().positive('Selezionare un distaccamento'),
  gdprConsent: z.literal(true, { errorMap: () => ({ message: 'Accettazione GDPR obbligatoria' }) }),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email('Email non valida'),
});

export const resetPasswordSchema = z
  .object({
    password: z.string()
      .min(8, 'Password: minimo 8 caratteri')
      .regex(/[A-Z]/, 'Richiede almeno una maiuscola')
      .regex(/[0-9]/, 'Richiede almeno un numero'),
    confirm: z.string(),
  })
  .refine((data) => data.password === data.confirm, {
    message: 'Le password non coincidono',
    path: ['confirm'],
  });

export const interventionSchema = z.object({
  category: z.enum(['Soccorso', 'Incendio', 'Stradale', 'Altro']),
  note: z.string().max(2000).optional().nullable(),
});

export const warehouseItemSchema = z.object({
  category: z.enum(['Abbigliamento', 'DpiIndividuale', 'AttrezziHoldable', 'Consumabili', 'Altro']),
  name: z.string().min(1, 'Nome obbligatorio').max(200),
  quantity: z.number().min(0, 'Quantita >= 0'),
  unit: z.string().max(20).optional(),
  serialNumber: z.string().max(100).optional(),
  expiry: z.string().optional(),
  notes: z.string().max(1000).optional(),
});

export const createSelectiveSchema = z.object({
  type: z.string().min(1, 'Tipo obbligatorio').max(100),
  priority: z.enum(['Alta', 'Media', 'Bassa']),
  callerInfo: z.string().max(500).optional(),
  recipient: z.string().max(200).optional(),
  zone: z.string().max(200).optional(),
  notes: z.string().max(2000).optional(),
  target: z.enum(['all', 'available']),
});

/**
 * Converte un errore Zod in Record<string, string>
 * utilizzabile per mostrare errori sotto ciascun campo.
 */
export function formatZodErrors<T>(result: z.SafeParseError<T>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const issue of result.error.issues) {
    const path = issue.path.join('.');
    if (!out[path]) out[path] = issue.message;
  }
  return out;
}
